import "./AddAnimeSeries.scss";
import React, { useState, useRef } from "react";

function AddAnimeSeries() {
  const [seriesName, setSeriesName] = useState("");
  const [seriesLogo, setSeriesLogo] = useState(""); // preview only
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setSeriesLogo(URL.createObjectURL(file)); // preview
    }
  };

  const handleSelectImage = () => {
    fileInputRef.current.click();
  };

  const handleSave = () => {
    try {
      const formData = new FormData();
      formData.append("subFolderName", seriesName);
      formData.append("seriesName", seriesName);
      if (selectedFile) {
        formData.append("seriesLogo", selectedFile); // ✅ append file itself
      }

      fetch(`${process.env.REACT_APP_BASE_URL}api/product/add-anime-series`, {
        method: "POST",
        body: formData, // ✅ no headers, browser sets them
      })
        .then((res) => res.json())
        .then((data) => {
          //console.log("Anime series saved successfully:", data);
          alert("Anime series saved successfully!!");
          handleCancel();
        })
        .catch((err) => console.error("Error saving series:", err));
    } catch (err) {
      console.error("Upload error:", err.message);
      alert("Internal server error.");
    }
  };

  const handleCancel = () => {
    setSeriesName("");
    setSelectedFile(null);
    setSeriesLogo("");
    if (fileInputRef.current) fileInputRef.current.value = ""; // clear input
  };

  return (
    <div className="aas-container">
      <div className="aas-input-wrapper">
        <label>Anime Series:</label>
        <input
          type="text"
          value={seriesName}
          onChange={(e) => setSeriesName(e.target.value)}
        />
      </div>

      <div className="aas-input-wrapper">
        <button onClick={handleSelectImage}>UPLOAD IMAGE</button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".jpg,.jpeg,.png"
          onChange={handleFileChange}
        />
        <p>FILE EXTENSION: .JPG, .JPEG, .PNG</p>

        {seriesLogo && <img src={seriesLogo} alt="Preview" />}
      </div>

      <div className="aas-btn-action-wrapper">
        <button className="cancel-btn" onClick={handleCancel}>
          Cancel
        </button>
        <button className="save-btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </div>
  );
}

export default AddAnimeSeries;
